import { SessionStatus } from '@heidi/schema/ml-scribe';

type StartNowConsumableSession = {
  session_id?: string | null;
  duration?: number | null;
  session_status?: SessionStatus | string | null;
};

/**
 * Whether Start is spent: stop/save in flight, any recording, or status past
 * `EMPTY`. Notes alone keep Start. Also keeps commenced rows in Today.
 */
export function isStartNowConsumedSession(
  session: StartNowConsumableSession,
  stoppedSessionIds?: ReadonlySet<string> | null
): boolean {
  if (session.session_id && stoppedSessionIds?.has(session.session_id)) {
    return true;
  }
  if ((session.duration ?? 0) > 0) return true;
  const status = session.session_status;
  return status != null && String(status) !== String(SessionStatus.EMPTY);
}
